import { SessionService } from '@tech-services/session.service';
import { environment } from '@tech-environments/environment';
import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './common.service';

import { Router } from '@angular/router';
import { AppConfig } from '@tech-utils/app-config.service';
import {
  LoginService as sdkService,
  ClientLogin,
  ClientDataLoginInterface,
  CommonService as sdkCommonService,
} from '@techrules/portallib';
import { TechDialogsService } from '../../shared/tech-dialogs.service';

@Injectable()
export class LoginService {
  HttpHeaders: HttpHeaders;
  private http: HttpClient;

  constructor(
    private httpBackend: HttpBackend,
    private session: SessionService,
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private router: Router,
    private commonService: CommonService,
    private sdkSvc: sdkService,
    private sdkCommonService: sdkCommonService
  ) {}

  validationLoginClientRest(
    password: string,
    username: string,
    deviceid: string,
    forcelogin: boolean
  ): Observable<ClientDataLoginInterface> {
    return this.sdkSvc.validationLoginClientRest(password, username, deviceid, forcelogin).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  sendResetPassMailClient(
    username: string,
    domain: string,
    language: string,
    email: string
  ): Observable<any> {
    return this.sdkSvc
      .sendResetPassMailClient(username, domain, language, email)
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          // this.commonService.errorManager('user_sendresetpassmailclient', err);
          return throwError(err);
        })
      );
  }
sendRegisterClient(
    email: string
  ): Observable<any> {
    return this.sdkSvc
      .sendRegisterClient(email)
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.errorManager('sendRegisterClient', err);
          return throwError(err);
        })
      );
  }

  validateTokenModifyPassword(token: string): Observable<any> {
    return this.sdkSvc.validateTokenModifyPassword(token).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager(
          'client_validatetokenmodifypassword',
          err
        );
        return throwError(err);
      })
    );
  }

  modifyPassword(token: string, password: string): Observable<any> {
    return this.sdkSvc.modifyPassword(token, password).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('client_modifypassword', err);
        return throwError(err);
      })
    );
  }

  activateaccount(ta: string): Observable<any> {
    return this.sdkSvc.activateaccount(ta).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err);
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }

  getBussinesAreaData(domain: string): Observable<any> {
    return this.sdkCommonService.getBussinesAreaData(domain).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err);
        this.router.navigate(['/login']);
        return throwError(err);
      })
    );
  }
}
